module.exports = __webpack_public_path__ + "img/ebafb17.jpg";